import Dexie, { type Table } from 'dexie';

import { DATABASE_NAME, DATABASE_SCHEMA_VERSION } from './databaseConfig';
import type {
  AppPreferencesRecord,
  BackupMetadataRecord,
  DailyRoutineRecord,
  DailyStepRecord,
  EmotionalProtocolLogRecord,
  ExerciseLogRecord,
  JournalEntryRecord,
  PhilosophyEntryRecord,
  ProfileRecord,
  RoutineStepTemplateRecord,
  RoutineTemplateRecord,
  WorkoutSessionRecord,
} from './records';
import { DATABASE_SCHEMA_V1 } from './schemaV1';

export class AscendInvictusDatabase extends Dexie {
  public readonly profiles!: Table<ProfileRecord, string>;
  public readonly routineTemplates!: Table<RoutineTemplateRecord, string>;
  public readonly routineStepTemplates!: Table<RoutineStepTemplateRecord, string>;
  public readonly dailyRoutines!: Table<DailyRoutineRecord, string>;
  public readonly dailySteps!: Table<DailyStepRecord, string>;
  public readonly journalEntries!: Table<JournalEntryRecord, string>;
  public readonly workoutSessions!: Table<WorkoutSessionRecord, string>;
  public readonly exerciseLogs!: Table<ExerciseLogRecord, string>;
  public readonly philosophyEntries!: Table<PhilosophyEntryRecord, string>;
  public readonly emotionalProtocolLogs!: Table<EmotionalProtocolLogRecord, string>;
  public readonly appPreferences!: Table<AppPreferencesRecord, string>;
  public readonly backupMetadata!: Table<BackupMetadataRecord, string>;

  public constructor(databaseName: string = DATABASE_NAME) {
    super(databaseName);
    this.version(DATABASE_SCHEMA_VERSION).stores(DATABASE_SCHEMA_V1);
  }
}
